import React from 'react';

import { PropertiesPanel } from '@paragon/layout-models';

import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { BasicInsertionProperties } from '../../../controls/basic-insertion/BasicInsertionProperties';
import { useAppSelector } from '../../../hooks';
import InsertionPanelContainer from './InsertionPanelContainer';

export function MemberInsertionSubPanel() {
  const activeComponentDesign = useAppSelector(getActiveComponentDesign);
  const insertionInfo = useAppSelector(({ application: { insertingObjectInfo } }) =>
    insertingObjectInfo && insertingObjectInfo.type === 'member' ? insertingObjectInfo : null,
  );

  if (activeComponentDesign?.component.referenceLines == null || insertionInfo == null) return null;

  return (
    <InsertionPanelContainer hideSubmitButton>
      <PropertiesPanel title="Member Insertion">
        <BasicInsertionProperties type="member" />
      </PropertiesPanel>
    </InsertionPanelContainer>
  );
}
